import { request } from '@umijs/max';

/** 事件列表 GET /robot/event/list */
export function getEventList(
  data: API.PageParams & API.EVENT.EventSearch = {
    pageNum: 1,
    pageSize: 12,
  },
) {
  const { pageNum, pageSize, ...searchQuery } = data;
  return request<API.ListResponse<API.EVENT.Event>>('/robot/event/list', {
    method: 'GET',
    params: data,
  });
}

/** 更新事件 PUT /robot/event/update */
export function updateEventData(
  data: Omit<API.EVENT.Event, 'updateTime' | 'taskId' | 'taskName'>,
) {
  return request<API.BaseResponse>('/robot/event/update', {
    method: 'PUT',
    data,
  });
}

export const EVENT_TYPE_MAP: Record<
  API.EVENT.EventType,
  { key: string; color: string; label: string }
> = {
  '1': {
    key: '1',
    color: 'volcano',
    label: '急停',
  },
  '2': {
    key: '2',
    color: 'magenta',
    label: '异常',
  },
  '3': {
    key: '3',
    color: 'red',
    label: '告警',
  },
  '11': {
    key: '11',
    color: 'green',
    label: '电力设备检查',
  },
  '12': {
    key: '12',
    color: 'lime',
    label: '消防通道检查',
  },
  '13': {
    key: '13',
    color: 'cyan',
    label: '灭火设备检查',
  },
  '14': {
    key: '14',
    color: 'blue',
    label: '环境卫生检查',
  },
  '15': {
    key: '15',
    color: 'gold',
    label: '照明设备检查',
  },
  '16': {
    key: '16',
    color: 'geekblue',
    label: '行为监测',
  },
  '17': {
    key: '17',
    color: 'purple',
    label: '展品保护状态监测',
  },
};

export const EVENT_MODE_MAP: Record<
  API.EVENT.EventMode,
  { key: API.EVENT.EventMode; color: string; label: string }
> = {
  '1': {
    key: '1' as API.EVENT.EventMode,
    color: 'blue',
    label: '作业事件',
  },
  '2': {
    key: '2' as API.EVENT.EventMode,
    color: 'cyan',
    label: '设备事件',
  },
  '3': {
    key: '3' as API.EVENT.EventMode,
    color: 'blue',
    label: '任务报告',
  },
};

export const DEVICE_EVENT_TYPE_COLUMN_ENUM: Record<
  API.EVENT.DeviceEventType,
  { text: string }
> = {
  '1': {
    text: '急停',
  },
  '2': {
    text: '异常',
  },
};

export const TASK_EVENT_TYPE_COLUMN_ENUM: Record<
  API.EVENT.TaskEventType,
  { text: string }
> = {
  '3': {
    text: '告警',
  },
  '11': {
    text: '电力设备检查',
  },
  '12': {
    text: '消防通道检查',
  },
  '13': {
    text: '灭火设备检查',
  },
  '14': {
    text: '环境卫生检查',
  },
  '15': {
    text: '照明设备检查',
  },
  '16': {
    text: '行为监测',
  },
  '17': {
    text: '展品保护状态监测',
  },
};

export const EVENT_TYPE_COLUMN_ENUM: Record<
  API.EVENT.EventType,
  { text: string }
> = { ...DEVICE_EVENT_TYPE_COLUMN_ENUM, ...TASK_EVENT_TYPE_COLUMN_ENUM };

export const EVENT_HANDLED_STATUS: Record<
  API.EVENT.HandledStatus,
  { value: string; label: string; color: string; color1: string }
> = {
  '0': {
    value: '0',
    label: '待处理',
    color: 'danger',
    color1: 'var(--ant-color-error)',
  },
  '1': {
    value: '1',
    label: '已解决',
    color: 'green',
    color1: 'var(--ant-color-success)',
  },
  '2': {
    value: '2',
    label: '已忽略',
    color: 'default',
    color1: 'var(--ant-color-text-secondary)',
  },
  '3': {
    value: '3',
    label: '待处理',
    color: 'danger',
    color1: 'var(--ant-color-error)',
  },
};
